export default __webpack_public_path__ + "static/Theworldsmostendangeredsound-bec1a3a4cf26efc63dfbd0e48b9e877e.jpg";